import React from "react";
import {useNavigate} from 'react-router-dom'
import "./Services.scss"; // Import the CSS styles
import bridalImg from "../../assets/photos/FormalCouple.jpg";
import standarImg from "../../assets/photos/AlterationArt2.jpg";
import specialtyImg from "../../assets/photos/AlterationArt3.jpg";
import customImg from "../../assets/photos/AlterationArt5.jpg";
import { Helmet } from "react-helmet-async";

const servicesAlts = [
    {
      path:"standard",
      title: "Standard Alterations",
      description: "Perfect for everyday tailoring needs, such as hemming, resizing, and adjustments.",
      imgSrc: standarImg, // Replace with your image path
    },
    {
      path:"bridal",
      title: "Bridal Alterations",
      description: "Expert adjustments for wedding gowns and bridal party attire to ensure a perfect fit.",
      imgSrc: bridalImg, // Replace with your image path
    },
    {
      path:"specialty",
      title: "Specialty Alterations",
      description: "Tailoring for unique fabrics, vintage pieces, or intricate designs.",
      imgSrc: specialtyImg, // Replace with your image path
    },
    {
      path:"custom",
      title: "Custom Tailoring",
      description: "Create unique, bespoke garments designed specifically for you.",
      imgSrc: customImg, // Replace with your image path
    },
    ];

const Services = () => {

  const navigate = useNavigate();

  return (
    <div className="services-container">
      <Helmet>
        <title>Expert Alterations | Custom, Bridal, & More | Cooper City, FL</title>
        <meta name="description" content="Explore our expert alteration services, including bridal, standard, specialty, and custom tailoring. Quality alterations for every occasion in Cooper City, FL." />
        <link rel="canonical" href="https://www.alterationsbysdenka-paola.com/services" />
      </Helmet>
      <div className="services-page">
        <h1 className="page-title">Expert Alterations for Your Unique Style</h1>
        <div className="services-grid">
          {servicesAlts.map((service, index) => (
            <div className="service-card" key={index} onClick={()=>{navigate(`/services/${service.path}`)}}>
              <img src={service.imgSrc} alt={service.title} className="service-image" />
              <h2 className="service-title">{service.title}</h2>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;